// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wc-icon-alert .alert-icon-col{min-width:50px;max-width:50px;padding-right:0}", ""]);
// Exports
module.exports = exports;
